import { Navigate, createBrowserRouter, useLocation } from 'react-router-dom';
import { Suspense, lazy, type ReactElement } from 'react';
import AppLayout from '../layouts/AppLayout';
import Dashboard from '../pages/Dashboard';
import EvaluationSupplier from '../pages/EvaluationSupplier';
import GoodsSupplier from '../pages/GoodsSupplier';
import Login from '../pages/Login';
import OrderSupplier from '../pages/OrderSupplier';
import ReturnSupplier from '../pages/ReturnSupplier';
import ScreenDevices from '../pages/ScreenDevices';
import ScreenScan from '../pages/ScreenScan';
import SettleSupplier from '../pages/SettleSupplier';
import ShopStock from '../pages/ShopStock';
import { useAuthStore } from '../session';

// 供应商大屏（/screen）：图表重、单独懒加载，登录端首屏不携带大屏代码
const ScreenPage = lazy(() => import('../pages/ScreenPage'));

function RequireAuth({ children }: { children: ReactElement }) {
  const token = useAuthStore((state) => state.token);
  const location = useLocation();
  if (!token) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return children;
}

export const router = createBrowserRouter([
  { path: '/login', element: <Login /> },
  {
    // 大屏全屏路由：不套 AppLayout、不走账号登录态门禁（屏端凭「设备凭据」独立换只读令牌），
    // 未授权时页内展示激活页（屏端凭设备凭据独立取数，与账号登录态无关）
    path: '/screen',
    element: (
      <Suspense fallback={null}>
        <ScreenPage />
      </Suspense>
    )
  },
  {
    path: '/',
    element: (
      <RequireAuth>
        <AppLayout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: 'dashboard', element: <Dashboard /> },
      { path: 'goods', element: <GoodsSupplier /> },
      { path: 'order', element: <OrderSupplier /> },
      // 可供库存：外仓供货指令（GY），可见范围由后端按令牌绑定的供应商主体裁剪
      { path: 'stock', element: <ShopStock /> },
      { path: 'settle', element: <SettleSupplier /> },
      { path: 'return', element: <ReturnSupplier /> },
      { path: 'evaluation', element: <EvaluationSupplier /> },
      // 大屏：本主体已授权设备（可吊销）+ 申请码确认（输入屏上 4-4-4 三段申请码）
      { path: 'screen-devices', element: <ScreenDevices /> },
      { path: 'screen-scan', element: <ScreenScan /> }
    ]
  },
  { path: '*', element: <Navigate to="/dashboard" replace /> }
]);
